import { Route, Redirect } from "react-router-dom";

import { authenticationService } from "../../services/authentication";

function PrivateRoute({ children, ...rest }) {
  const currentUser = authenticationService.currentUserValue;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        currentUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
